import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom'; // Import Link for navigation

const StructureList = () => {
    const [structureAssets, setStructureAssets] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchStructureAssets = async () => {
            try {
                const physicalResponse = await axios.get('/api/balance_sheet/assets/physical_assets/resi_properties/structures');
                setStructureAssets(physicalResponse.data);
            } catch (error) {
                console.error("Error fetching assets:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchStructureAssets();
    }, []);

    if (loading) {
        return <div>Loading structure assets...</div>;
    }

    return (
        <div className="structure-assets-page">
        <div style={{ margin: '20px' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <h1 style={{ marginRight: '20px' }}>Physical Structure Assets</h1>
                <div>
                    <Link to="/assets/physical_assets/resi_properties"> Residential Property Assets</Link>
                </div>
            </div>
        </div>
            <table className="structure-asset-table">
                <thead>
                    <tr>
                        <th>Asset ID</th>
                        <th>Construction End Date</th>
                        <th>Total Build Cost</th>
                        <th>Residential Property</th>
                    </tr>
                </thead>
                <tbody>
                    {structureAssets.length > 0 ? (
                        structureAssets.map(structure_asset => (
                            <tr key={structure_asset.id}>
                                <td>
                                    <Link to={`/assets/physical_assets/resi_properties/structures/${structure_asset.id}`}>{structure_asset.id}
                                    </Link>
                                </td>
                                <td>
                                    {structure_asset.construction_end_date}
                                </td>
                                <td>
                                    {structure_asset.total_build_cost}
                                </td>
                                <td>
                                    <Link to={`/assets/physical_assets/resi_properties/${structure_asset.residential_property}`}>
                                        {structure_asset.residential_property}
                                    </Link>
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="3" style={{ textAlign: 'center' }}>No physical structure assets found.</td>
                        </tr>
                    )}
                </tbody>
            </table>
            <style jsx>{`
                .structure-assets-page {
                    padding: 20px;
                    max-width: 800px;
                    margin: 0 auto;
                }
                .structure-assets-table {
                    width: 100%;
                    border-collapse: collapse;
                    margin-top: 20px;
                }
                .structure-assets-table th, .structure-assets-table td {
                    border: 1px solid #ccc;
                    padding: 10px;
                    text-align: left;
                }
                .structure-assets-table th {
                    background-color: #f0f0f0;
                }
            `}</style>
        </div>
    );
};

export default StructureList;